// Plan #1 §4.3 — pure assist-eligibility logic. No IO, no prng.
export const ASSIST_UNLOCK_SHOT = 5; // eligible once shots.length >= 5 → shots 6 and 7 (D5)

export function assistEligible(a: {
  assistEnabled: boolean;
  shotsThisRound: number;
  alreadyRevealedThisRound: boolean;
}): boolean {
  return a.assistEnabled
    && a.shotsThisRound >= ASSIST_UNLOCK_SHOT
    && !a.alreadyRevealedThisRound;
}

export function assistUsedToday(getRevealDate: () => string | null, date: string): boolean {
  return getRevealDate() === date;
}
